import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollector,
  FieldSelectGroup,
  FieldSelectNomos,
  FieldSelectRegion,
} from 'shared-pages';
import { Company } from 'shared-pages/common/constants';
import {
  isAfisCyprus,
  isFotokiklosi,
  isMedicycle,
  isRebattery,
} from 'shared-pages/common/constants';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  let where = {};

  if (values) {
    // Search text filtering (matching orderNo, notes, judgeByUser)
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      where = {
        ...where,
        $or: [{ orderNo: { $like: searchText } }, { notes: { $like: searchText } }],
      };
    }

    // Active status filter
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.collectionPointId) {
      where = { ...where, collectionPointId: values.collectionPointId };
    }
    // Filtering by Order Type

    // Filtering by Collector
    if (values.collectorId) {
      where = { ...where, collectorId: values.collectorId };
    }

    if (values.addressNomos) {
      where = { ...where, '$collectionpoint.addressNomos$': values.addressNomos };
    }
    if (values.regionId) {
      where = { ...where, '$collectionpoint.regionId$': values.regionId };
    }

    // Date range filtering for `dateOrdered`
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'dateOrdered'),
      };
    }
  }

  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm = false }) => {
  //

  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    collectorId: initialValues?.collectorId ?? undefined,
    regionId: initialValues?.regionId ?? undefined,
    addressNomos: initialValues?.addressNomos ?? undefined,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Αριθμός, Σημειώσεις )')}
          type="search"
          disable={disable}
        />
        <FieldDateRanger
          as={FormCol}
          label={t('Παραγγελία από')}
          name="startDate"
          name2="endDate"
        />
        <FieldSelectCollector as={FormCol} />

        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
        {isFotokiklosi && <FieldSelectNomos as={FormCol} />}
        {(isRebattery || isAfisCyprus || isMedicycle) && <FieldSelectRegion as={FormCol} />}
      </Row>
    </FormFilterCard>
  );
};

